module.exports = [
  'SalonService', 'RESTService', (SalonService, RESTService) ->
    (id) ->
      RESTService.service('special_offers', SalonService.one(id))
]
